import { render } from "./productLevel.vue?vue&type=template&id=5223bf7c&scoped=true"
import script from "./productLevel.vue?vue&type=script&lang=js"
export * from "./productLevel.vue?vue&type=script&lang=js"

import "./productLevel.vue?vue&type=style&index=0&id=5223bf7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5223bf7c"]])

export default __exports__